module.exports = __webpack_public_path__ + "static/media/RAMAX.f3f89af7.gif";